import * as React from "react";
import { css } from "@emotion/core";
import { IKnowledgeBaseArticle } from "../../../api/knowledgeBase";
import { extractSnippet, highlightText } from "../utils/searchHighlight";

type SearchResultsProps = {
  searchResults: IKnowledgeBaseArticle[];
  searchQuery: string;
  activeIndex: number;
  onSelectResult: (articleId: number) => void;
  onHoverResult: (index: number) => void;
  getBreadcrumbTitles: (articleId: number) => string[];
};

const SearchResults = ({
  searchResults,
  searchQuery,
  activeIndex,
  onSelectResult,
  onHoverResult,
  getBreadcrumbTitles,
}: SearchResultsProps) => (
  <>
    {searchResults.map((article, idx) => {
      const breadcrumb = getBreadcrumbTitles(article.id);
      const isActive = idx === activeIndex;

      return (
        <button
          key={article.id}
          onClick={() => onSelectResult(article.id)}
          onMouseEnter={() => onHoverResult(idx)}
          aria-selected={isActive}
          css={css`
            text-align: left;
            padding: 0.75rem;
            cursor: pointer;
            transition: background 120ms ease, border 120ms ease;
            border-radius: 4px;
            border: 0;
            background: ${isActive ? "#2c343d" : "transparent"};
            outline: none;

            &:hover {
              background: #2c343d;
            }
          `}
        >
          <div
            css={css`
              font-weight: 700;
            `}
          >
            {highlightText(article.title, searchQuery, {
              highlightColor: "var(--neutral-2)",
              nonHighlightColor: "var(--neutral-4)",
              matchTag: "span",
            })}
          </div>

          {breadcrumb.length > 0 && (
            <div
              css={css`
                color: var(--neutral-4);
                font-size: 0.725rem;
                margin-top: 0.25rem;
              `}
            >
              {highlightText(breadcrumb.join(" / "), searchQuery, {
                highlightColor: "var(--neutral-2)",
                nonHighlightColor: "var(--neutral-4)",
                matchTag: "strong",
                useWordBoundary: false,
              })}
            </div>
          )}

          <div
            css={css`
              margin-top: 0.25rem;
              color: var(--neutral-5);
              font-size: 0.875rem;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
              overflow: hidden;
              text-overflow: ellipsis;
            `}
          >
            {extractSnippet(article.content_plain || "", searchQuery, 256)}
          </div>
        </button>
      );
    })}
  </>
);

export default SearchResults;
